import React from "react";
import "./AppBarVertical.style.css";
import { Link } from "react-router-dom";

const AppBarVertical = () => {
  return (
    <div className="VerticalAppBar__container">
      <div className="VerticalAppBar__logo" style={{display:"flex", flexDirection:"row", justifyContent:"center", alignItems:"center"}}>
        <img src="/images/btm.png" alt="btm" width="150px" height="80px" />
      </div>
      <nav className="VerticalAppBar__nav">
        <ul>
          <li>
            <Link to="/main" className="nav-link">Inicio</Link>
          </li>
          <li>
            <Link to="/main/about" className="nav-link">Acerca de</Link>
          </li>
          <li>
            <Link to="/main/novedades" className="nav-link">Novedades</Link>
          </li>
          <li>
            <Link to="/main/tournament" className="nav-link">Torneos</Link>
          </li>
          <li>
            <Link to="/main/documentation" className="nav-link">Documentos</Link>
          </li>
          <li>
            <Link to="/main/nextEvents" className="nav-link">Proximos Eventos</Link>
          </li>
          <li>
            <Link to="/main/attendance" className="nav-link">Asistencia</Link>
          </li>
          <li>
            <Link to="/main/ranking" className="nav-link">Ranking</Link>
          </li>
          <li>
            <Link to="/main/wheel" className="nav-link">Ruleta</Link>
          </li>
          <li>
            <Link to="/main/contact" className="nav-link">Contactanos</Link>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default AppBarVertical;
